<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 3)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <!-- <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/walk/0.png"> -->
        <!-- <img id="partner" src="@/assets/game4-10/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="chushuiAudio" preload="auto">
          <source :src="this.chushuiAudio">
        </audio>
        <audio id="tiaoshuiAudio" preload="auto">
          <source :src="this.tiaoshuiAudio">
        </audio>
        <audio id="wanyaoAudio" preload="auto">
          <source :src="this.wanyaoAudio">
        </audio>
        <audio id="successAudio" preload="auto">
          <source :src="this.successAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title" v-html="moreName"></div>
          <img  class="start"  :class="{'btn-restart': isLoop}" @click="startGameHandler(true)"  :src="startBtn"/>          
          <!-- <div class="mask-title">海豹钻圈</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/> -->
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.allAudioVoice = new Howl({
      src: [this.allAudio],
      html5: isIOS
    });
    // this.chushuiAudioVoice = new Howl({
    //   src: [this.chushuiAudio],
    //   html5: isIOS
    // });
    // this.tiaoshuiAudioVoice = new Howl({
    //   src: [this.tiaoshuiAudio],
    //   html5: isIOS
    // });
    // this.wanyaoAudioVoice = new Howl({
    //   src: [this.wanyaoAudio],
    //   html5: isIOS
    // });
    // this.successAudioVoice = new Howl({
    //   src: [this.successAudio],
    //   html5: isIOS
    // });
  },
  beforeDestroy () {
    this.allAudioVoice.pause()
    // this.chushuiAudioVoice.pause()
    // this.tiaoshuiAudioVoice.pause()
    // this.wanyaoAudioVoice.pause()
    // this.successAudioVoice.pause()
  },
  data() {
    return {
      allAudioVoice: null,
      chushuiAudioVoice: null,
      tiaoshuiAudioVoice: null,
      wanyaoAudioVoice: null,
      successAudioVoice: null,
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      allAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/sounds/4-10.mp3`,
      chushuiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/sounds/chushui.mp3`,
      tiaoshuiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/sounds/tiaoshui.mp3`,
      wanyaoAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/sounds/wanyao.mp3`,
      successAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/sounds/huanhu.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 120
    }
  },
  methods: {
    isEmpty,
    // 面板动画
    boardGifHandler (id, index) {
      clearInterval(this.timerBoard)
      this.timerBoard = null
     
      const animeType = this.animeTypes
      let i = 0
      const wordTarget = document.querySelector(`#${id} div`)
      const wrapTarget = document.querySelector(`#${id}`)

      wordTarget.style.display = 'none'
      for(let i=index; i>=0; i--) {
        const iconImg = document.querySelector(`#word${index} .icon-img`)
        iconImg.style.zIndex = 60
      }

      const target = document.querySelector(`#${id} .flower`)
      const icon = document.querySelector(`#${id} .icon`)
      const iconImg = document.querySelector(`#${id} .icon-img`)
      this.timerBoard = setInterval(() => {
        this.isWalk = true
        // if (i == 19) {
        //   this.allAudioVoice.play()
        // }
        // if (i == 19) {
        //   // document.getElementById(`chushuiAudio`).play()
        //   this.chushuiAudioVoice.play()
        // }
        // if (i == 32) {
        //   // document.getElementById(`wanyaoAudio`).play()
        //   this.wanyaoAudioVoice.play()
        // }
        // if (i == 50) {
        //   // document.getElementById(`tiaoshuiAudio`).play()
        //   this.tiaoshuiAudioVoice.play()
        // }
        // if (i == 81) {
        //   // document.getElementById(`successAudio`).play()
        //   this.successAudioVoice.play()
        // }
        if (i>=this.boardImgLength-1) {
          clearInterval(this.timerBoard)
          this.timerBoard = null
          // 隐藏星星
          // target.style.display = 'none'
          wrapTarget.style.visibility = 'hidden'

          // this.isWalk = false
          this.showWordList[index].clicked = false
          target.style.display = 'none'
          target.style.zIndex = 40
          icon.style.zIndex = 60
          iconImg.style.zIndex = 60
          // 下一个字包括音效 
          this.getData(true)
        } else {
          i=i+1
          target.style.zIndex = 99
          icon.style.zIndex = 70
          iconImg.style.zIndex = 70
          target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type${animeType}/${i}.png`
          // target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type${animeType}/${i}.png`
        }
      }, 75)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        return false
      }

      this.showWordList[index].clicked = true

      this.playClickAudio()
      this.allAudioVoice.play()
      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/anime/type0/${0}.png`
      this.boardGifHandler(`word${index}`, index)
      console.log('isVertical', this.isVertical)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-10/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    z-index: 990;
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  height: 50%;
  align-items: center;
  width: 90%;
  &:nth-of-type(1) {
    // margin-left: 120px;
    margin-left: 3%;
    margin-top: 70px;
  }
  &:nth-of-type(2) {
    margin-top: -50px;
    margin-left: 3%;
  }
  .word {
    transform-origin: center;
    width: 200px;
    height: 300px;
    font-size: 30px;
    margin-top: -15%;
    // font-weight: bolder;
    position: relative;
    z-index: auto;
    .flower {
      height: 85%;
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: -20px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 75%;
      height: 40%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 14%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 84px;
      height: 84px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 20%;
    }
  }
}
#person {
  width: 213px;
  height: 250px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  z-index: 40;
}
#partner {
  width: 203.66px;
  height: 281.5px;
  position: fixed;
  right: 10px;
  bottom: 0px;
}
}
</style>